var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 41,
    viewBox: "0 0 115 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4698 14.3828C71.7678 12.6789 69.7111 11.8262 67.2991 11.8262C64.886 11.8262 62.8293 12.6789 61.127 14.3828C59.4246 16.0862 58.5746 18.1347 58.5746 20.5262C58.5746 22.9513 59.4246 25.024 61.127 26.7443C62.8293 28.4649 64.886 29.3244 67.2991 29.3244C69.7111 29.3244 71.7678 28.4649 73.4698 26.7443C75.1722 25.024 76.0232 22.9513 76.0232 20.5262C76.0232 18.1347 75.1722 16.0862 73.4698 14.3828ZM76.7153 29.7199C74.112 32.2905 70.9641 33.5755 67.2739 33.5755C63.6164 33.5755 60.4855 32.2905 57.8822 29.7199C55.2786 27.1496 53.9773 24.0526 53.9773 20.427C53.9773 16.868 55.2786 13.8366 57.8822 11.3319C60.4855 8.82813 63.6164 7.57512 67.2739 7.57512C70.9641 7.57512 74.112 8.82813 76.7153 11.3319C79.3182 13.8366 80.6205 16.868 80.6205 20.427C80.6205 24.0526 79.3182 27.1496 76.7153 29.7199ZM40.0874 11.8262C37.7471 11.8262 35.8115 12.6541 34.2795 14.3084C32.7471 15.9638 31.981 18.0358 31.981 20.5262C31.981 22.9187 32.7631 24.9829 34.3287 26.7195C35.8934 28.4564 37.7641 29.3244 39.9389 29.3244C41.4223 29.3244 42.8062 28.9175 44.0912 28.1021C45.3765 27.287 46.3482 26.1788 47.0077 24.777H52.1483C51.2255 27.4795 49.6769 29.621 47.502 31.2033C45.3269 32.7849 42.8222 33.5755 39.9885 33.5755C36.4295 33.5755 33.4392 32.3235 31.0171 29.8188C28.5949 27.3147 27.384 24.2171 27.384 20.5262C27.384 16.9013 28.6027 13.8366 31.0415 11.3319C33.4797 8.82813 36.4951 7.57512 40.0874 7.57512C42.921 7.57512 45.4829 8.42417 47.7735 10.121C50.0642 11.8184 51.5221 13.9355 52.1483 16.4725H47.0077C45.2939 13.3759 42.9869 11.8262 40.0874 11.8262ZM18.1162 13.8037C16.5503 12.3535 14.7298 11.6288 12.6538 11.6288C10.1827 11.6288 8.1557 12.5183 6.57409 14.2977C5.58539 15.4185 4.94256 17.0001 4.64628 19.0432H20.6121C20.5136 17.0001 19.6812 15.2538 18.1162 13.8037ZM25.0613 22.6019H4.64628C5.14063 24.6302 6.12085 26.2584 7.58727 27.4847C9.05337 28.711 10.7919 29.3244 12.8023 29.3244C15.8337 29.3244 18.1567 27.9405 19.7719 25.1722H24.4185C23.4957 27.7428 21.963 29.7865 19.8212 31.3018C17.6786 32.8179 15.2741 33.5755 12.6046 33.5755C9.14441 33.5755 6.17861 32.299 3.70684 29.7447C1.23572 27.1917 0 24.1182 0 20.5262C0 16.9013 1.23572 13.8037 3.70684 11.233C6.17861 8.6627 9.17671 7.3777 12.7034 7.3777C16.1303 7.3777 19.0716 8.6379 21.5268 11.1589C23.9816 13.68 25.2094 16.7039 25.2094 20.2293C25.2094 20.7569 25.1599 21.5479 25.0613 22.6019Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.295 21.5203V24.3109H110.342V21.5203L108.057 16.6508H110.182L111.319 19.7282L112.467 16.6508H114.569L112.295 21.5203ZM104.634 19.0277L103.831 21.6463H105.427L104.634 19.0277ZM106.323 24.3109L105.955 23.1969H103.291L102.889 24.3109H100.787L103.854 16.6508H105.405L108.447 24.3109H106.323ZM98.9385 24.3109H97.2162L96.0562 19.3611L94.8965 24.3109H93.139L91.1636 16.6508H93.1505L94.1728 21.6348L95.3096 16.6508H96.8142L97.9393 21.658L98.9848 16.6508H100.971L98.9385 24.3109Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4986 26.558L70.3122 19.5864H67.9886L68.6523 14.7724L64.6685 21.4121H66.8263L65.4986 26.558Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6641 0H68.1538V5.14585H65.6641V0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.7612 19.2549H87.9071V21.745H82.7612V19.2549Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3735 37.2106L57.5327 38.4554L60.1086 33.9994L57.9497 32.7545L55.3735 37.2106Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4155 3.78893L57.5718 2.54407L60.1447 7.00011L57.9885 8.24497L55.4155 3.78893Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6108 3.39126L76.4924 2.16011L73.9648 6.56753L76.0832 7.79868L78.6108 3.39126Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5677 11.2395L84.3486 9.11359L79.9556 11.6669L81.1746 13.7928L85.5677 11.2395Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6382 35.854H68.1279V40.9999H65.6382V35.854Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5989 37.6076L76.4776 38.8387L73.9468 34.4316L76.0678 33.2001L78.5989 37.6076Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5643 29.7594L84.3439 31.8856L79.9453 29.3319L81.166 27.206L85.5643 29.7594Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.84a1607b77c7d18edce26b793502bdbd.svg";
export { ForwardRef as ReactComponent };